import { render, staticRenderFns } from "./editproduct.vue?vue&type=template&id=1bc5bbe7&scoped=true"
import script from "./editproduct.vue?vue&type=script&lang=js"
export * from "./editproduct.vue?vue&type=script&lang=js"
import style0 from "./editproduct.vue?vue&type=style&index=0&id=1bc5bbe7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5bbe7",
  null
  
)

export default component.exports